
//Import asset file(s) used by this module.
import '../../assets/skins/SplashAssets.js';
import '../../assets/skins/MainAssets.js';

import AppInstaller from '../../../shared/src/ranj/app/core/AppInstaller.js';
import ContextEvent from "../../../shared/src/ranj/app/core/ContextEvent";
import SkinKeys from '../../../shared/src/ranj/app/ui/SkinKeys.js';
import SplashLoadScreenMediator from './flexibility/view/SplashLoadScreenMediator.js';
import AbstractInstaller from '../../../shared/src/ranj/app/core/AbstractInstaller.js';

import GameConfig from './flexibility/model/GameConfig.js';
import GameModel from './flexibility/model/GameModel.js';
import RoadBuilder from './flexibility/view/RoadBuilder.js';
import InitFlexGameTask from './flexibility/core/InitFlexGameTask.js';
import GameScreenMediator from './flexibility/view/GameScreenMediator.js';
import EndScreenMediator from './flexibility/view/EndScreenMediator.js';
import StartGameCommand from './flexibility/controller/StartGameCommand.js';
import InitPlatformAPIServiceTask from '../../../shared/src/ranj/equalture/platform/InitPlatformAPIServiceTask.js';
import ShowSplashScreenTask from '../../../shared/src/ranj/equalture/startup/ShowSplashScreenTask.js';
import LoadStartupAssetsTask from '../../../shared/src/ranj/app/startup/LoadStartupAssetsTask.js';
import InitLanguageTask from '../../../shared/src/ranj/equalture/startup/InitLanguageTask.js';
import GameEvent from '../../../shared/src/ranj/app/core/GameEvent.js';
import ExitGameCommand from '../../../shared/src/ranj/app/core/ExitGameCommand.js';
import TutorialOverlayMediator from './flexibility/view/TutorialOverlayMediator.js';
import CountdownMediator from './flexibility/view/CountdownMediator.js';
import TrackingController from './flexibility/model/TrackingController.js';
import SaveModel from './flexibility/model/SaveModel.js';
import AppModel from '../../../shared/src/ranj/app/core/AppModel.js';
import FinishMediator from './flexibility/view/FinishMediator.js';
import SaveEvent from '../../../shared/src/ranj/equalture/savegame/SaveEvent.js';
import SaveCommand from '../../../shared/src/ranj/equalture/savegame/SaveCommand.js';
import TutorialPlayer from './flexibility/controller/TutorialPlayer.js';
import InterruptGameCommand from '../../../shared/src/ranj/app/core/InterruptGameCommand.js';
import DebugOutputController from '../debug/modules/debugoutput/DebugOutputController.js';

export default class MinigameInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "SplashAssets");
        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "sounds", "common", "MainAssets");


        commands.add(ContextEvent.START_GAME, StartGameCommand);
        commands.add(GameEvent.EXIT, ExitGameCommand);
        commands.add(GameEvent.INTERRUPT_GAME, InterruptGameCommand);

        injector.mapClass("appModel", AppModel, true);
        injector.mapClass("gameModel", GameModel, true);
        injector.mapClass("trackingController", TrackingController, true);
        injector.mapClass("gameConfig", GameConfig, true);
        injector.mapClass("roadBuilder", RoadBuilder, true);
        injector.mapClass("tutorialPlayer", TutorialPlayer, false);
        injector.mapValue("roadAssets", lib.MainAssets);

        injector.mapClass("saveModel", SaveModel, true);
        commands.add(SaveEvent.SAVE, SaveCommand);
        commands.add(SaveEvent.CLEAR, SaveCommand);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "preload");
        this._addStartupTask(InitFlexGameTask, "initFlexGameTask", 0, ["LoadStartupAssetsTask"]);

        this._addStartupTask(InitPlatformAPIServiceTask, "InitPlatformAPIServiceTask", 0);
        this._addStartupTask(InitLanguageTask, "InitLanguageTask", 0, ["InitPlatformAPIServiceTask"]);
        this._addStartupTask(ShowSplashScreenTask, "ShowSplashScreenTask", 0);
        this._addStartupTask(LoadStartupAssetsTask, "LoadStartupAssetsTask", 30, ["InitLanguageTask"]);

        SkinKeys.SPLASH_LOAD_SCREEN_SKIN = this._mapMediator(SplashLoadScreenMediator, lib.SplashAssets.SplashLoadScreenSkin);
        SkinKeys.GAME_SCREEN_SKIN = this._mapMediator(GameScreenMediator, lib.MainAssets.GameScreenSkin);
        SkinKeys.END_SCREEN_SKIN = this._mapMediator(EndScreenMediator, lib.MainAssets.EndScreenSkin);
        SkinKeys.TUTORIAL_OVERLAY_SKIN = this._mapMediator(TutorialOverlayMediator, lib.MainAssets.TutorialOverlaySkin);
        SkinKeys.COUNTDOWN_SKIN = this._mapMediator(CountdownMediator, lib.MainAssets.CountdownSkin);
        SkinKeys.FINISH_SKIN = this._mapMediator(FinishMediator, lib.MainAssets.FinishMovieclip);

/////////////////////
////////////////////////////////////////////////////////////////////
//////////////////
    }

};
